var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLdss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20360",
    "data-name": "Group 20360",
    transform: "translate(-220 -2595)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7903",
    "data-name": "Rectangle 7903",
    width: 220,
    height: 220,
    transform: "translate(220 2595)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Webinar-pana",
    transform: "translate(236.79 2652.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    transform: "translate(1.665 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36320",
    "data-name": "Path 36320",
    d: "M580.588,202.63h37.656l-6.134,4.427v8.721a1.818,1.818,0,0,1-1.818,1.818h-29.7a1.818,1.818,0,0,1-1.818-1.818V204.448a1.818,1.818,0,0,1,1.818-1.818Z",
    transform: "translate(-433.49 -161.112)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36321",
    "data-name": "Path 36321",
    d: "M591.59,225.736c0,.037,5.679.066,12.685.066s12.685-.029,12.685-.066-5.679-.066-12.685-.066S591.59,225.7,591.59,225.736Z",
    transform: "translate(-442.922 -178.064)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36322",
    "data-name": "Path 36322",
    d: "M591.59,238.386c0,.037,5.679.066,12.685.066s12.685-.029,12.685-.066-5.679-.066-12.685-.066S591.59,238.352,591.59,238.386Z",
    transform: "translate(-442.922 -187.371)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7858",
    "data-name": "Rectangle 7858",
    width: 1.763,
    height: 5.904,
    transform: "translate(88.145 9.382)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7859",
    "data-name": "Rectangle 7859",
    width: 1.763,
    height: 6.757,
    transform: "translate(73.425 8.529)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7860",
    "data-name": "Rectangle 7860",
    width: 1.763,
    height: 8.166,
    transform: "translate(77.106 7.12)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7861",
    "data-name": "Rectangle 7861",
    width: 1.763,
    height: 7.719,
    transform: "translate(80.785 7.567)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7862",
    "data-name": "Rectangle 7862",
    width: 1.763,
    height: 10.33,
    transform: "translate(84.464 4.956)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7863",
    "data-name": "Rectangle 7863",
    width: 1.763,
    height: 10.28,
    transform: "translate(91.824 5.006)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7864",
    "data-name": "Rectangle 7864",
    width: 1.763,
    height: 6.903,
    transform: "translate(95.505 8.383)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7865",
    "data-name": "Rectangle 7865",
    width: 1.763,
    height: 9.828,
    transform: "translate(99.184 5.458)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7866",
    "data-name": "Rectangle 7866",
    width: 1.763,
    height: 12.04,
    transform: "translate(102.865 3.246)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7867",
    "data-name": "Rectangle 7867",
    width: 1.763,
    height: 9.878,
    transform: "translate(106.544 5.408)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36323",
    "data-name": "Path 36323",
    d: "M573.494,60.267l14.572-2.228a14.746,14.746,0,1,1-12.949-12.421Z",
    transform: "translate(-418.755 -45.528)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36324",
    "data-name": "Path 36324",
    d: "M627.528,46,625.76,57.295l11.1-2.082S635.218,48.891,627.528,46Z",
    transform: "translate(-468.061 -45.875)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36325",
    "data-name": "Path 36325",
    d: "M51.478,184.638a7.225,7.225,0,1,1,7.341,7.135A7.225,7.225,0,0,1,51.478,184.638Zm10.679-.174a3.465,3.465,0,1,0-.972,2.47A3.454,3.454,0,0,0,62.158,184.463Z",
    transform: "translate(-45.546 -142.494)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36326",
    "data-name": "Path 36326",
    d: "M51.477,184.466a7.252,7.252,0,0,1,7.109-7.376l.061,3.787a3.473,3.473,0,0,0,.1,6.942l.069,3.782A7.249,7.249,0,0,1,51.477,184.466Z",
    transform: "translate(-45.544 -142.322)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36327",
    "data-name": "Path 36327",
    d: "M75.93,174.874a8.261,8.261,0,0,1,8.457,8.227l-4.413.069a3.626,3.626,0,0,0-3.964-3.61Z",
    transform: "translate(-63.536 -140.689)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7868",
    "data-name": "Rectangle 7868",
    width: 9.186,
    height: 10.92,
    transform: "translate(43.692 67.63)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7869",
    "data-name": "Rectangle 7869",
    width: 41.509,
    height: 12.318,
    transform: "translate(2.503 66.917)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36328",
    "data-name": "Path 36328",
    d: "M201.609,299.776H191.35V298.74h10.259a.529.529,0,0,1,.529.529h0A.529.529,0,0,1,201.609,299.776Z",
    transform: "translate(-148.454 -231.823)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36329",
    "data-name": "Path 36329",
    d: "M201.609,342.466H191.35V341.43h10.259a.529.529,0,0,1,.529.529h0A.529.529,0,0,1,201.609,342.466Z",
    transform: "translate(-148.454 -263.232)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7870",
    "data-name": "Rectangle 7870",
    width: 4.905,
    height: 12.318,
    transform: "translate(35.843 66.917)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7871",
    "data-name": "Rectangle 7871",
    width: 4.905,
    height: 12.318,
    transform: "translate(6.448 67.054)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36330",
    "data-name": "Path 36330",
    d: "M204.4,308.116c0,.032-1.987.055-4.44.055s-4.44-.024-4.44-.055,1.987-.056,4.44-.056S204.4,308.086,204.4,308.116Z",
    transform: "translate(-151.521 -238.68)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36331",
    "data-name": "Path 36331",
    d: "M204.4,314.316c0,.029-1.987.053-4.44.053s-4.44-.024-4.44-.053,1.987-.056,4.44-.056S204.4,314.284,204.4,314.316Z",
    transform: "translate(-151.521 -243.242)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36332",
    "data-name": "Path 36332",
    d: "M204.4,321.946c0,.029-1.987.053-4.44.053s-4.44-.024-4.44-.053,1.987-.056,4.44-.056S204.4,321.919,204.4,321.946Z",
    transform: "translate(-151.521 -248.855)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36333",
    "data-name": "Path 36333",
    d: "M204.4,329.573c0,.032-1.987.055-4.44.055s-4.44-.024-4.44-.055,1.987-.053,4.44-.053S204.4,329.544,204.4,329.573Z",
    transform: "translate(-151.521 -254.469)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36334",
    "data-name": "Path 36334",
    d: "M204.4,337.2c0,.032-1.987.055-4.44.055s-4.44-.024-4.44-.055,1.987-.053,4.44-.053S204.4,337.174,204.4,337.2Z",
    transform: "translate(-151.521 -260.083)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7872",
    "data-name": "Rectangle 7872",
    width: 18.673,
    height: 2.217,
    transform: "translate(14.532 71.98)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7873",
    "data-name": "Rectangle 7873",
    width: 9.326,
    height: 6.654,
    transform: "translate(43.459 79.478)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7874",
    "data-name": "Rectangle 7874",
    width: 39.688,
    height: 7.135,
    transform: "translate(3.877 79.234)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36335",
    "data-name": "Path 36335",
    d: "M192.78,345.834H202.8a.24.24,0,0,0,.24-.24h0a.243.243,0,0,0-.241-.243H192.78Z",
    transform: "translate(-149.506 -266.116)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36336",
    "data-name": "Path 36336",
    d: "M192.78,370.53h10.153a.111.111,0,0,1,.111.111v.264a.111.111,0,0,1-.111.111H192.78v-.486Z",
    transform: "translate(-149.506 -284.641)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36337",
    "data-name": "Path 36337",
    d: "M203.093,350.9c0,.029-2.067.055-4.612.055s-4.612-.026-4.612-.055,2.064-.056,4.612-.056S203.093,350.866,203.093,350.9Z",
    transform: "translate(-150.308 -270.155)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36338",
    "data-name": "Path 36338",
    d: "M203.093,355.663c0,.032-2.067.055-4.612.055s-4.612-.024-4.612-.055,2.064-.053,4.612-.053S203.093,355.634,203.093,355.663Z",
    transform: "translate(-150.308 -273.664)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36339",
    "data-name": "Path 36339",
    d: "M203.093,360.426c0,.029-2.067.053-4.612.053s-4.612-.024-4.612-.053,2.064-.056,4.612-.056S203.093,360.394,203.093,360.426Z",
    transform: "translate(-150.308 -277.166)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36340",
    "data-name": "Path 36340",
    d: "M203.093,365.186c0,.029-2.067.053-4.612.053s-4.612-.024-4.612-.053,2.064-.056,4.612-.056S203.093,365.154,203.093,365.186Z",
    transform: "translate(-150.308 -280.668)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7875",
    "data-name": "Rectangle 7875",
    width: 9.519,
    height: 18.037,
    transform: "translate(44.68 87.007)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7876",
    "data-name": "Rectangle 7876",
    width: 44.68,
    height: 19.556,
    transform: "translate(0 86.372)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36341",
    "data-name": "Path 36341",
    d: "M204.965,442.819H193.48V441.55h11.485a.637.637,0,0,1,.634.634h0a.634.634,0,0,1-.634.634Z",
    transform: "translate(-150.021 -336.893)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36342",
    "data-name": "Path 36342",
    d: "M193.48,372.36h11.829a.291.291,0,0,1,.291.291v.687a.291.291,0,0,1-.291.291H193.48V372.36Z",
    transform: "translate(-150.021 -285.988)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36343",
    "data-name": "Path 36343",
    d: "M207.634,383.753c0,.032-2.13.056-4.757.056s-4.757-.024-4.757-.056,2.13-.053,4.757-.053S207.634,383.724,207.634,383.753Z",
    transform: "translate(-153.434 -294.331)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36344",
    "data-name": "Path 36344",
    d: "M207.634,392.506c0,.029-2.13.053-4.757.053s-4.757-.024-4.757-.053,2.13-.056,4.757-.056S207.634,392.474,207.634,392.506Z",
    transform: "translate(-153.434 -300.768)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36345",
    "data-name": "Path 36345",
    d: "M207.634,401.255c0,.029-2.13.055-4.757.055s-4.757-.026-4.757-.055,2.13-.055,4.757-.055S207.634,401.226,207.634,401.255Z",
    transform: "translate(-153.434 -307.206)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36346",
    "data-name": "Path 36346",
    d: "M207.634,410.013c0,.032-2.13.055-4.757.055s-4.757-.024-4.757-.055,2.13-.053,4.757-.053S207.634,409.984,207.634,410.013Z",
    transform: "translate(-153.434 -313.651)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36347",
    "data-name": "Path 36347",
    d: "M207.634,418.766c0,.029-2.13.053-4.757.053s-4.757-.024-4.757-.053,2.13-.055,4.757-.055S207.634,418.734,207.634,418.766Z",
    transform: "translate(-153.434 -320.089)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36348",
    "data-name": "Path 36348",
    d: "M207.634,427.516c0,.029-2.13.056-4.757.056s-4.757-.026-4.757-.056,2.13-.056,4.757-.056S207.634,427.486,207.634,427.516Z",
    transform: "translate(-153.434 -326.526)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36349",
    "data-name": "Path 36349",
    d: "M207.634,436.273c0,.032-2.13.056-4.757.056s-4.757-.024-4.757-.056,2.13-.053,4.757-.053S207.634,436.244,207.634,436.273Z",
    transform: "translate(-153.434 -332.971)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36350",
    "data-name": "Path 36350",
    d: "M76.2,398.84v1.089c0,1.321-.655,2.059-1.919,2.059s-1.919-.748-1.919-2.059v-4.257c0-1.321.655-2.061,1.919-2.061s1.919.751,1.919,2.061v.793H74.982v-.875c0-.587-.264-.809-.666-.809s-.669.222-.669.809v4.421c0,.587.264.793.669.793s.666-.209.666-.793V398.84Z",
    transform: "translate(-60.909 -301.622)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36351",
    "data-name": "Path 36351",
    d: "M89.45,395.671a1.956,1.956,0,1,1,3.906,0v4.257a1.956,1.956,0,1,1-3.906,0Zm1.287,4.339c0,.587.264.809.666.809s.666-.222.666-.809v-4.421c0-.587-.264-.809-.666-.809s-.666.222-.666.809Z",
    transform: "translate(-73.483 -301.622)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36352",
    "data-name": "Path 36352",
    d: "M107.37,394h1.287v7.019h2.114v1.173h-3.4Z",
    transform: "translate(-86.667 -301.909)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36353",
    "data-name": "Path 36353",
    d: "M122,395.671a1.957,1.957,0,1,1,3.909,0v4.257a1.957,1.957,0,1,1-3.909,0Zm1.287,4.339c0,.587.264.809.666.809s.669-.222.669-.809v-4.421c0-.587-.264-.809-.669-.809s-.666.222-.666.809Z",
    transform: "translate(-97.431 -301.622)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36354",
    "data-name": "Path 36354",
    d: "M140.977,394v6.319c0,.584.264.793.666.793s.666-.211.666-.793V394h1.218v6.237c0,1.308-.655,2.059-1.919,2.059s-1.919-.751-1.919-2.059V394Z",
    transform: "translate(-110.446 -301.909)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36355",
    "data-name": "Path 36355",
    d: "M160.213,402.192a2.482,2.482,0,0,1-.119-1.007V399.9c0-.761-.264-1.041-.84-1.041h-.447v3.335H157.52V394h1.942c1.321,0,1.908.621,1.908,1.884v.642a1.626,1.626,0,0,1-.843,1.662c.645.264.854.888.854,1.742V401.2a2.4,2.4,0,0,0,.143.994Zm-1.406-7.019v2.513h.5c.478,0,.772-.209.772-.864v-.809c0-.584-.2-.84-.655-.84Z",
    transform: "translate(-123.564 -301.909)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36356",
    "data-name": "Path 36356",
    d: "M83.218,355.323H82.28l.05-.243h2.154l-.053.243H83.5l-.484,2.415h-.277Z",
    transform: "translate(-68.208 -273.274)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36357",
    "data-name": "Path 36357",
    d: "M90.066,357.563l-1.459,2.257c-.248.381-.433.5-.721.5a.647.647,0,0,1-.476-.177l.143-.2a.478.478,0,0,0,.354.145c.172,0,.3-.082.46-.325l.14-.211-.5-1.987h.264l.423,1.7,1.091-1.7Z",
    transform: "translate(-71.982 -275.099)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36358",
    "data-name": "Path 36358",
    d: "M99.224,358.35a1.126,1.126,0,0,1-1.131,1.189.751.751,0,0,1-.761-.436l-.227,1.155H96.84l.544-2.735h.264l-.063.32a1.01,1.01,0,0,1,.793-.336.806.806,0,0,1,.846.843Zm-.264.016a.587.587,0,0,0-.658-.624.872.872,0,0,0-.869.951.581.581,0,0,0,.658.621.872.872,0,0,0,.862-.949Z",
    transform: "translate(-78.92 -275.059)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36359",
    "data-name": "Path 36359",
    d: "M107.047,358.7a1.134,1.134,0,0,1,1.155-1.187.82.82,0,0,1,.909.843,1.136,1.136,0,0,1-1.155,1.189.822.822,0,0,1-.909-.846Zm1.794-.328a.587.587,0,0,0-.658-.624.88.88,0,0,0-.867.938.584.584,0,0,0,.658.621.875.875,0,0,0,.867-.936Z",
    transform: "translate(-86.428 -275.061)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36360",
    "data-name": "Path 36360",
    d: "M117.96,357.537l-.349,1.755a1.063,1.063,0,0,1-1.163,1,1.274,1.274,0,0,1-.888-.3l.159-.206a1.057,1.057,0,0,0,.751.264.793.793,0,0,0,.864-.716l.048-.219a1.031,1.031,0,0,1-.793.341.79.79,0,0,1-.883-.793,1.1,1.1,0,0,1,1.139-1.134.766.766,0,0,1,.78.457l.085-.441Zm-.455.793c0-.365-.246-.581-.661-.581a.848.848,0,0,0-.869.883c0,.365.243.581.661.581a.848.848,0,0,0,.869-.875Z",
    transform: "translate(-92.693 -275.073)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36361",
    "data-name": "Path 36361",
    d: "M127.411,357.5l-.05.264h-.074a.794.794,0,0,0-.811.74l-.2,1.015h-.264l.4-2h.264l-.082.373A.906.906,0,0,1,127.411,357.5Z",
    transform: "translate(-100.381 -275.054)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36362",
    "data-name": "Path 36362",
    d: "M133.734,357.514l-.4,2h-.264l.063-.315a1.017,1.017,0,0,1-.777.333.806.806,0,0,1-.872-.846,1.126,1.126,0,0,1,1.128-1.187.751.751,0,0,1,.761.433l.085-.418Zm-.449.843a.587.587,0,0,0-.658-.624.877.877,0,0,0-.864.938.581.581,0,0,0,.65.621.875.875,0,0,0,.867-.935Z",
    transform: "translate(-104.408 -275.05)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36363",
    "data-name": "Path 36363",
    d: "M143.154,358.348a1.126,1.126,0,0,1-1.131,1.189.75.75,0,0,1-.761-.436l-.227,1.155h-.264l.542-2.735h.264l-.063.32a1,1,0,0,1,.777-.336.809.809,0,0,1,.864.843Zm-.264.016a.587.587,0,0,0-.658-.624.872.872,0,0,0-.872.951.581.581,0,0,0,.655.621.872.872,0,0,0,.867-.949Z",
    transform: "translate(-111.24 -275.057)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36364",
    "data-name": "Path 36364",
    d: "M153.142,355.946a1.154,1.154,0,0,1-.021.227l-.227,1.136h-.264l.23-1.139a1.185,1.185,0,0,0,.018-.182c0-.285-.172-.449-.529-.449a.777.777,0,0,0-.811.7l-.214,1.07h-.264l.563-2.82h.264l-.225,1.121a.983.983,0,0,1,.764-.314C152.894,355.288,153.142,355.531,153.142,355.946Z",
    transform: "translate(-118.811 -272.84)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36365",
    "data-name": "Path 36365",
    d: "M161.121,357.57l-1.453,2.257c-.248.381-.433.5-.721.5a.648.648,0,0,1-.476-.177l.145-.2a.468.468,0,0,0,.351.145c.172,0,.3-.082.46-.325l.143-.211-.5-1.987h.264l.412,1.7,1.091-1.7Z",
    transform: "translate(-124.263 -275.106)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36366",
    "data-name": "Path 36366",
    d: "M78.427,46.79H37.89L44.5,51.547v9.374a1.956,1.956,0,0,0,1.958,1.958H78.432a1.958,1.958,0,0,0,1.958-1.958V48.748a1.958,1.958,0,0,0-1.964-1.958Z",
    transform: "translate(-35.549 -46.456)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36367",
    "data-name": "Path 36367",
    d: "M108.857,71.661c0,.04-6.113.071-13.652.071S81.55,71.7,81.55,71.661s6.113-.071,13.655-.071S108.857,71.622,108.857,71.661Z",
    transform: "translate(-67.67 -64.702)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36368",
    "data-name": "Path 36368",
    d: "M108.857,85.281c0,.04-6.113.071-13.652.071s-13.655-.032-13.655-.071,6.113-.071,13.655-.071S108.857,85.242,108.857,85.281Z",
    transform: "translate(-67.67 -74.723)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2",
    transform: "translate(0 105.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36369",
    "data-name": "Path 36369",
    d: "M207.863,446.159c0,.04-41.448.069-92.561.069s-92.572-.029-92.572-.069,41.438-.069,92.572-.069S207.863,446.122,207.863,446.159Z",
    transform: "translate(-22.73 -446.09)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2",
    transform: "translate(6.749 61.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36370",
    "data-name": "Path 36370",
    d: "M625.9,330.476s-7.006-8.06-9.648-16.121-1.387-7.135-1.387-7.135,3.568,7.833,6.276,11.615,7.548,9.329,7.548,9.329Z",
    transform: "translate(-464.908 -299.31)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36371",
    "data-name": "Path 36371",
    d: "M660.6,311.408a.407.407,0,0,0-.758.264,107.294,107.294,0,0,1,1.321,13.79c-.048,5.6,0,7.764,0,7.764h2.907s-.529-11.575-1.176-15.106A24.026,24.026,0,0,0,660.6,311.408Z",
    transform: "translate(-498.217 -302.258)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36372",
    "data-name": "Path 36372",
    d: "M668.75,329.528a30.917,30.917,0,0,0,2.4-8.705c.24-2.061-.19-4.847-.827-8.565a23.169,23.169,0,0,1-.367-4.12.695.695,0,0,1,1.305-.328,18.6,18.6,0,0,1,1.631,4.117c.706,3.671,1.5,5.507.893,8.985a54.031,54.031,0,0,1-2.87,8.848Z",
    transform: "translate(-504.775 -299.5)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36373",
    "data-name": "Path 36373",
    d: "M678.68,317.359s7.693-16.53,8.227-18.983,2.344-8.1,2.558-7.783a11.417,11.417,0,0,1-.854,6.718c-1.382,3.412-7.3,20.55-7.3,20.55H678.68",
    transform: "translate(-512.081 -287.091)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36374",
    "data-name": "Path 36374",
    d: "M628.3,329.406a1.775,1.775,0,0,1-.217-.148c-.135-.1-.344-.248-.595-.455a26.631,26.631,0,0,1-2.067-1.826,34.619,34.619,0,0,1-5.581-7.162,46.807,46.807,0,0,1-3.808-8.251c-.386-1.1-.669-2-.851-2.622-.1-.309-.161-.555-.206-.719a1.38,1.38,0,0,1-.058-.264,1.646,1.646,0,0,1,.09.246l.235.711c.2.618.5,1.512.9,2.6a50.094,50.094,0,0,0,3.842,8.208,36.071,36.071,0,0,0,5.526,7.17c.822.819,1.527,1.44,2.024,1.85.246.214.447.367.576.478a1.613,1.613,0,0,1,.19.182Z",
    transform: "translate(-465.171 -299.877)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36375",
    "data-name": "Path 36375",
    d: "M663.251,324.955a2.951,2.951,0,0,1-.069-.484c-.037-.344-.085-.793-.14-1.321-.122-1.121-.312-2.661-.584-4.355s-.576-3.219-.811-4.318c-.114-.529-.209-.967-.28-1.3a2.955,2.955,0,0,1-.087-.484,2.815,2.815,0,0,1,.148.468c.087.3.2.745.333,1.292.264,1.094.587,2.619.859,4.318s.444,3.245.529,4.368c.048.563.077,1.017.09,1.321A2.364,2.364,0,0,1,663.251,324.955Z",
    transform: "translate(-499.279 -303.358)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36376",
    "data-name": "Path 36376",
    d: "M673.4,308.35a1.232,1.232,0,0,1,.09.211c.061.156.137.359.233.613s.217.595.33.986.264.824.373,1.321l.19.777c.066.264.111.558.169.851.127.587.2,1.224.3,1.892a28.182,28.182,0,0,1-.312,8.737c-.14.661-.264,1.29-.431,1.866-.079.288-.145.571-.23.835s-.167.529-.246.764c-.148.489-.325.914-.468,1.292s-.28.7-.4.959l-.264.595a1.137,1.137,0,0,1-.106.2,1.175,1.175,0,0,1,.077-.217l.243-.608c.111-.264.243-.584.373-.965s.3-.809.444-1.3c.074-.243.153-.5.235-.761s.143-.547.219-.835c.161-.576.264-1.2.415-1.85a29.243,29.243,0,0,0,.312-8.692c-.09-.666-.161-1.3-.28-1.884-.058-.293-.1-.579-.161-.848s-.122-.529-.18-.777c-.1-.5-.243-.936-.349-1.321s-.209-.719-.3-.988-.151-.465-.2-.624A1.19,1.19,0,0,1,673.4,308.35Z",
    transform: "translate(-507.629 -300.164)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36377",
    "data-name": "Path 36377",
    d: "M692.862,291.89a.2.2,0,0,1,0,.074,1.758,1.758,0,0,1-.034.214c-.034.188-.077.468-.151.825a30.006,30.006,0,0,1-.793,2.976c-.4,1.242-.906,2.7-1.53,4.3s-1.342,3.343-2.024,5.2-1.229,3.663-1.731,5.3-.967,3.118-1.424,4.334a27.876,27.876,0,0,1-1.213,2.828c-.159.328-.3.571-.391.74l-.108.188a.26.26,0,0,1-.042.063.3.3,0,0,1,.026-.071l.1-.2c.082-.174.214-.423.362-.753.309-.655.727-1.617,1.163-2.838s.9-2.693,1.39-4.337,1.023-3.457,1.718-5.315,1.411-3.6,2.04-5.2,1.165-3.044,1.559-4.279.663-2.249.83-2.955c.085-.351.137-.629.182-.814.021-.085.037-.153.05-.211A.241.241,0,0,1,692.862,291.89Z",
    transform: "translate(-515.568 -288.054)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36378",
    "data-name": "Path 36378",
    d: "M626.288,277.559a.663.663,0,0,0-1.091.677,18.829,18.829,0,0,0,.967,2.484c1.057,2.249,4.165,10.307,5.618,14.738s3.5,12.685,3.5,12.685l3.105-.5s-2.841-13.57-5.6-18.473C630.543,285.25,628.313,279.573,626.288,277.559Z",
    transform: "translate(-472.71 -277.376)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36379",
    "data-name": "Path 36379",
    d: "M653.41,356.28a1.808,1.808,0,0,1,.161.373c.092.243.217.6.357,1.041.285.885.637,2.114.988,3.5s.645,2.627.848,3.533c.1.428.172.793.235,1.076a2.067,2.067,0,0,1,.063.4,1.893,1.893,0,0,1-.127-.383c-.074-.283-.169-.639-.283-1.057l-.9-3.531c-.351-1.374-.684-2.614-.941-3.5l-.307-1.057A2.016,2.016,0,0,1,653.41,356.28Z",
    transform: "translate(-493.489 -335.428)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36380",
    "data-name": "Path 36380",
    d: "M637.839,308.266a.372.372,0,0,1-.016-.082,1.946,1.946,0,0,0-.037-.246c-.032-.214-.061-.529-.127-.941-.114-.814-.317-1.99-.65-3.422a49.655,49.655,0,0,0-1.453-4.96c-.637-1.85-1.435-3.827-2.341-5.885-1.826-4.109-3.65-7.754-4.849-10.447-.605-1.345-1.076-2.442-1.385-3.208-.159-.381-.264-.679-.349-.883-.034-.1-.063-.169-.087-.233a.3.3,0,0,1-.024-.079.657.657,0,0,1,.04.074c.024.05.061.135.1.225l.375.872c.328.756.814,1.85,1.432,3.171,1.224,2.682,3.066,6.316,4.894,10.431.906,2.061,1.7,4.054,2.333,5.9a47.276,47.276,0,0,1,1.424,4.992,34.826,34.826,0,0,1,.6,3.436c.055.41.074.729.1.946,0,.1.013.18.018.246A.345.345,0,0,1,637.839,308.266Z",
    transform: "translate(-473.705 -277.747)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36381",
    "data-name": "Path 36381",
    d: "M665.768,355.587a3.605,3.605,0,0,1-.106-.529c-.061-.365-.143-.846-.24-1.427-.214-1.2-.529-2.859-1.009-4.662s-.991-3.412-1.393-4.564l-.476-1.358a3.149,3.149,0,0,1-.164-.507,3.51,3.51,0,0,1,.225.484c.132.315.32.774.529,1.348a44.969,44.969,0,0,1,1.443,4.561,47.659,47.659,0,0,1,.964,4.686c.09.605.156,1.1.19,1.438A3.548,3.548,0,0,1,665.768,355.587Z",
    transform: "translate(-500.088 -325.319)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7877",
    "data-name": "Rectangle 7877",
    width: 12.119,
    height: 14.765,
    transform: "translate(159.932 29.821)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19298",
    "data-name": "Group 19298",
    transform: "translate(159.932 29.821)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7878",
    "data-name": "Rectangle 7878",
    width: 12.119,
    height: 14.765
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7879",
    "data-name": "Rectangle 7879",
    width: 10.751,
    height: 14.765,
    transform: "translate(157.434 29.821)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36382",
    "data-name": "Path 36382",
    d: "M61.434,368.033a6.393,6.393,0,0,0-6.934.056,7.132,7.132,0,0,0-2.793,6.078c.085,2.318,1.213,5.167,3.319,6.39l6.184-.026a8.3,8.3,0,0,0,3.4-6.239A7.214,7.214,0,0,0,61.434,368.033Z",
    transform: "translate(-50.794 -343.343)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36383",
    "data-name": "Path 36383",
    d: "M75.317,381.438a2.792,2.792,0,0,1-.037-.529c0-.381-.026-.867-.042-1.451-.032-1.224-.079-2.907-.161-4.781s-.182-3.557-.264-4.781c-.034-.581-.063-1.057-.087-1.448a2.754,2.754,0,0,1,0-.529,2.932,2.932,0,0,1,.085.529c.042.341.092.835.151,1.446.111,1.221.233,2.907.317,4.781s.108,3.565.1,4.791c0,.613,0,1.107-.021,1.451A2.907,2.907,0,0,1,75.317,381.438Z",
    transform: "translate(-67.724 -343.992)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36384",
    "data-name": "Path 36384",
    d: "M49.945,391.558c0,.053-.341.071-.751.037s-.737-.106-.735-.159.341-.071.751-.04S49.95,391.5,49.945,391.558Z",
    transform: "translate(-48.41 -361.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36385",
    "data-name": "Path 36385",
    d: "M51.132,382.608c-.024.05-.312-.029-.647-.18s-.589-.309-.568-.359.312.032.647.18S51.153,382.568,51.132,382.608Z",
    transform: "translate(-49.48 -354.391)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36386",
    "data-name": "Path 36386",
    d: "M55.212,375.506c-.029.045-.354-.108-.692-.388s-.552-.573-.513-.608.309.182.637.455S55.241,375.459,55.212,375.506Z",
    transform: "translate(-52.487 -348.838)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36387",
    "data-name": "Path 36387",
    d: "M61.185,369.5c-.05.021-.206-.222-.349-.544s-.219-.6-.169-.626.206.222.349.547S61.233,369.475,61.185,369.5Z",
    transform: "translate(-57.379 -344.289)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36388",
    "data-name": "Path 36388",
    d: "M67.881,365.286c-.05.021-.217-.238-.33-.6s-.122-.671-.069-.679.151.264.264.618S67.932,365.262,67.881,365.286Z",
    transform: "translate(-62.382 -341.115)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36389",
    "data-name": "Path 36389",
    d: "M78.765,364.407c.053.018.021.241-.069.5s-.206.447-.264.428-.021-.238.069-.494S78.715,364.388,78.765,364.407Z",
    transform: "translate(-70.44 -341.406)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36390",
    "data-name": "Path 36390",
    d: "M85.648,367.8c.037.04-.1.225-.3.412s-.4.307-.433.264.1-.225.3-.412S85.611,367.759,85.648,367.8Z",
    transform: "translate(-75.225 -343.897)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36391",
    "data-name": "Path 36391",
    d: "M92.332,372.3c.032.045-.132.209-.365.367s-.447.248-.478.2.135-.209.367-.367S92.3,372.253,92.332,372.3Z",
    transform: "translate(-80.065 -347.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36392",
    "data-name": "Path 36392",
    d: "M96.218,379.009c.021.05-.235.209-.576.354s-.634.222-.655.172.238-.209.579-.351S96.2,378.958,96.218,379.009Z",
    transform: "translate(-82.64 -352.139)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36393",
    "data-name": "Path 36393",
    d: "M98.269,386.252c0,.053-.264.132-.589.172s-.6.032-.61-.024.264-.13.587-.172S98.261,386.2,98.269,386.252Z",
    transform: "translate(-84.173 -357.442)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36394",
    "data-name": "Path 36394",
    d: "M99.35,393.956c-.021.05-.3-.024-.624-.164s-.571-.3-.55-.346.3.024.626.164S99.374,393.906,99.35,393.956Z",
    transform: "translate(-84.987 -362.761)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36395",
    "data-name": "Path 36395",
    d: "M98.114,400.8c-.018.05-.373-.034-.743-.277s-.589-.529-.552-.568.309.174.661.4S98.132,400.758,98.114,400.8Z",
    transform: "translate(-83.986 -367.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36396",
    "data-name": "Path 36396",
    d: "M95.007,407.343c-.032.042-.314-.122-.584-.415s-.415-.584-.373-.616.264.2.529.481S95.044,407.3,95.007,407.343Z",
    transform: "translate(-81.946 -372.236)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36397",
    "data-name": "Path 36397",
    d: "M55.417,411.023c.024.048-.264.264-.663.455a2.068,2.068,0,0,1-.761.283c-.034-.042.264-.264.661-.457S55.391,410.976,55.417,411.023Z",
    transform: "translate(-52.478 -375.697)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36398",
    "data-name": "Path 36398",
    d: "M52.707,404.627c.021.05-.217.206-.529.349s-.589.219-.613.169.217-.206.529-.349S52.683,404.577,52.707,404.627Z",
    transform: "translate(-50.693 -370.987)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36399",
    "data-name": "Path 36399",
    d: "M49.6,398.9c0,.053-.285.14-.655.193s-.671.05-.679,0,.285-.14.653-.19S49.6,398.849,49.6,398.9Z",
    transform: "translate(-48.269 -366.757)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36400",
    "data-name": "Path 36400",
    d: "M58.042,395.831c.016.053-.264.185-.647.227s-.69-.024-.684-.077.3-.077.661-.119S58.026,395.779,58.042,395.831Z",
    transform: "translate(-54.479 -364.509)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36401",
    "data-name": "Path 36401",
    d: "M65.773,388.843c.016.05-.211.167-.529.2s-.55-.037-.544-.09.243-.077.529-.106S65.757,388.79,65.773,388.843Z",
    transform: "translate(-60.358 -359.362)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36402",
    "data-name": "Path 36402",
    d: "M67.22,382.313c-.019.053-.264.013-.55-.085s-.5-.219-.484-.264.264-.013.55.087S67.239,382.263,67.22,382.313Z",
    transform: "translate(-61.451 -354.31)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36403",
    "data-name": "Path 36403",
    d: "M71.453,375.723c-.037.04-.206-.071-.328-.283s-.132-.41-.079-.423.143.14.264.325S71.493,375.686,71.453,375.723Z",
    transform: "translate(-65.004 -349.213)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36404",
    "data-name": "Path 36404",
    d: "M67.032,400.729c.013.053-.2.151-.476.219a1.781,1.781,0,0,1-.4.058l-.037-.116c.071,0,.116,0,.127.013s-.021.055-.079.1l-.04-.116a1.848,1.848,0,0,1,.383-.132C66.786,400.69,67.019,400.676,67.032,400.729Z",
    transform: "translate(-61.403 -368.106)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36405",
    "data-name": "Path 36405",
    d: "M67.422,410.686c.019.05-.264.2-.608.344s-.658.211-.677.161.264-.206.605-.344S67.406,410.636,67.422,410.686Z",
    transform: "translate(-61.415 -375.444)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36406",
    "data-name": "Path 36406",
    d: "M60.668,406.254c.018.05-.164.159-.4.24s-.449.108-.468.055.164-.159.4-.24S60.642,406.2,60.668,406.254Z",
    transform: "translate(-56.749 -372.175)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36407",
    "data-name": "Path 36407",
    d: "M60.091,384.853c0,.053-.328.021-.69-.108s-.629-.3-.605-.352.317.04.671.164S60.1,384.808,60.091,384.853Z",
    transform: "translate(-56.013 -356.102)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36408",
    "data-name": "Path 36408",
    d: "M80.341,383.961c.032.045-.145.214-.394.378s-.476.264-.507.214.148-.214.4-.378S80.312,383.908,80.341,383.961Z",
    transform: "translate(-71.2 -355.783)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36409",
    "data-name": "Path 36409",
    d: "M81.473,393.812c0,.053-.177.137-.418.188s-.444.048-.457,0,.177-.137.418-.188S81.46,393.76,81.473,393.812Z",
    transform: "translate(-72.054 -363.013)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36410",
    "data-name": "Path 36410",
    d: "M81.978,403.625c-.024.048-.293-.026-.6-.169a1.288,1.288,0,0,1-.529-.349c0-.05.293.026.6.169S82,403.575,81.978,403.625Z",
    transform: "translate(-72.24 -369.869)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36411",
    "data-name": "Path 36411",
    d: "M80.8,413.867c-.042.037-.217-.106-.388-.317s-.264-.41-.235-.444.214.108.388.32S80.841,413.83,80.8,413.867Z",
    transform: "translate(-71.74 -377.233)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36412",
    "data-name": "Path 36412",
    d: "M80.122,376.613c.034.042-.082.188-.28.285s-.381.106-.394.053.129-.137.307-.227S80.1,376.57,80.122,376.613Z",
    transform: "translate(-71.208 -350.377)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36413",
    "data-name": "Path 36413",
    d: "M88.374,386.612c.019.05-.211.177-.529.222s-.568-.016-.566-.069.246-.087.529-.127S88.356,386.562,88.374,386.612Z",
    transform: "translate(-76.971 -357.726)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36414",
    "data-name": "Path 36414",
    d: "M86.378,377.635c.024.048-.2.211-.529.314s-.6.1-.61.05.243-.14.55-.24S86.352,377.585,86.378,377.635Z",
    transform: "translate(-75.469 -351.128)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36415",
    "data-name": "Path 36415",
    d: "M88.86,399.752a2.35,2.35,0,0,1-1.654-.3,3.21,3.21,0,0,1,.84.108A2.4,2.4,0,0,1,88.86,399.752Z",
    transform: "translate(-76.914 -367.179)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36416",
    "data-name": "Path 36416",
    d: "M87.14,410.849c-.032.042-.32-.127-.605-.415s-.452-.566-.418-.608.264.19.552.47S87.169,410.807,87.14,410.849Z",
    transform: "translate(-76.112 -374.82)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36417",
    "data-name": "Path 36417",
    d: "M63.145,367a8.986,8.986,0,0,0-1.731,1.369,8.456,8.456,0,0,0-2.156,4.757,10.782,10.782,0,0,0,.129,2.92,23.139,23.139,0,0,0,.547,2.344c.19.658.365,1.187.481,1.554a3.869,3.869,0,0,1,.166.576,3.109,3.109,0,0,1-.238-.55c-.14-.359-.336-.883-.542-1.541a19.463,19.463,0,0,1-.592-2.352,10.4,10.4,0,0,1-.148-2.973,8.316,8.316,0,0,1,2.252-4.841,6.118,6.118,0,0,1,1.29-1,3.287,3.287,0,0,1,.4-.206A.582.582,0,0,1,63.145,367Z",
    transform: "translate(-56.176 -343.315)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36418",
    "data-name": "Path 36418",
    d: "M76.906,380.874c-.045-.024.441-.772.885-2.114a12,12,0,0,0,.529-5.452,10.267,10.267,0,0,0-.84-2.925,6.93,6.93,0,0,0-1.432-2,5.319,5.319,0,0,0-1.406-.888c-.365-.151-.584-.188-.581-.2a.529.529,0,0,1,.161,0,2.8,2.8,0,0,1,.447.119,4.852,4.852,0,0,1,1.469.856,6.736,6.736,0,0,1,1.506,2.022,10.093,10.093,0,0,1,.872,2.96,11.6,11.6,0,0,1-.595,5.526c-.111.341-.264.632-.362.9a4.614,4.614,0,0,1-.328.65A4.231,4.231,0,0,1,76.906,380.874Z",
    transform: "translate(-67.244 -343.526)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36419",
    "data-name": "Path 36419",
    d: "M55.89,416.93H66.773l.066,2.178H55.89Z",
    transform: "translate(-53.876 -380.05)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36420",
    "data-name": "Path 36420",
    d: "M59.39,421.05l.624,6.649h7.957l.64-6.575Z",
    transform: "translate(-56.451 -383.081)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36421",
    "data-name": "Path 36421",
    d: "M66.846,425c0,.055-2.45.1-5.473.1s-5.473-.042-5.473-.1,2.45-.1,5.473-.1S66.846,424.942,66.846,425Z",
    transform: "translate(-53.883 -385.914)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36422",
    "data-name": "Path 36422",
    d: "M69.759,431.091a1.639,1.639,0,0,1-.233.418,6.117,6.117,0,0,1-.846,1l-.05.048-.048-.053a15.643,15.643,0,0,0-2.135-1.866h.122l-.946.83-1.118.967-.061.056-.063-.053-1.816-1.527.106-.013c-.375.46-.692.843-.941,1.15a2.516,2.516,0,0,1-.37.4,2.962,2.962,0,0,1,.3-.455l.888-1.187.048-.061.061.048,1.85,1.5h-.122l1.113-.978.949-.827.058-.05.063.045a13.981,13.981,0,0,1,2.114,1.927h-.1A10.642,10.642,0,0,0,69.759,431.091Z",
    transform: "translate(-57.901 -389.982)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2",
    transform: "translate(26.287 22.791)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7880",
    "data-name": "Rectangle 7880",
    width: 122.902,
    height: 81.274,
    rx: 7,
    transform: "translate(4.033 0)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36423",
    "data-name": "Path 36423",
    d: "M122.211,419.44H255.364v2.408a4.7,4.7,0,0,1-4.7,4.7H126.9a4.7,4.7,0,0,1-4.7-4.7V419.44Z",
    transform: "translate(-122.2 -343.417)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36424",
    "data-name": "Path 36424",
    d: "M324.15,416.56l1.652,2.63h23.251l1.533-2.63Z",
    transform: "translate(-270.78 -341.298)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36425",
    "data-name": "Path 36425",
    d: "M259.3,416.339c0,.045-27.278.079-60.917.079s-60.928-.034-60.928-.079,27.273-.079,60.928-.079S259.3,416.294,259.3,416.339Z",
    transform: "translate(-133.427 -341.077)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7881",
    "data-name": "Rectangle 7881",
    width: 115.381,
    height: 68.441,
    rx: 3.27,
    transform: "translate(7.553 4.672)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36426",
    "data-name": "Path 36426",
    d: "M265.691,232.235H150.31l.124-63.425H265.691Z",
    transform: "translate(-142.881 -159.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36427",
    "data-name": "Path 36427",
    d: "M181.455,156.914a.922.922,0,1,1-.922-.914A.922.922,0,0,1,181.455,156.914Z",
    transform: "translate(-164.438 -149.597)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36428",
    "data-name": "Path 36428",
    d: "M160.325,156.914a.922.922,0,1,1-.914-.914A.922.922,0,0,1,160.325,156.914Z",
    transform: "translate(-148.892 -149.597)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36429",
    "data-name": "Path 36429",
    d: "M170.465,156.892a.92.92,0,1,1-.269-.653A.922.922,0,0,1,170.465,156.892Z",
    transform: "translate(-156.353 -149.575)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7882",
    "data-name": "Rectangle 7882",
    width: 115.505,
    height: 6.126,
    transform: "translate(7.429 67.088)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36430",
    "data-name": "Path 36430",
    d: "M164.13,396.911v.2h-.92v-.153l.494-.47a.345.345,0,0,0,.143-.264c0-.114-.079-.18-.233-.18a.349.349,0,0,0-.291.13l-.164-.124a.582.582,0,0,1,.476-.206c.264,0,.447.135.447.357a.5.5,0,0,1-.209.394l-.333.317Z",
    transform: "translate(-152.335 -326.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36431",
    "data-name": "Path 36431",
    d: "M167.3,397.148a.148.148,0,1,1,.145.148.143.143,0,0,1-.145-.148Zm0,.679a.148.148,0,1,1,.067.144A.148.148,0,0,1,167.3,397.827Z",
    transform: "translate(-155.378 -326.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36432",
    "data-name": "Path 36432",
    d: "M169.224,395.905v1.247h-.23V396.1h-.264v-.2Z",
    transform: "translate(-156.433 -326.098)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36433",
    "data-name": "Path 36433",
    d: "M172.6,396.943h-.222v.283h-.225v-.283h-.684v-.151l.616-.793h.248l-.581.769h.41v-.251h.217v.251h.222Z",
    transform: "translate(-158.449 -326.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7883",
    "data-name": "Rectangle 7883",
    width: 94.673,
    height: 0.431,
    transform: "translate(16.189 70.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7884",
    "data-name": "Rectangle 7884",
    width: 29.585,
    height: 1.152,
    transform: "translate(16.118 69.81)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36434",
    "data-name": "Path 36434",
    d: "M290.741,394.49a1.44,1.44,0,1,1-1.44-1.44A1.44,1.44,0,0,1,290.741,394.49Z",
    transform: "translate(-244.081 -324.001)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36435",
    "data-name": "Path 36435",
    d: "M547.971,396.013a.415.415,0,0,1-.455.41c-.341,0-.529-.219-.529-.621a.592.592,0,0,1,.613-.663.634.634,0,0,1,.328.082l-.087.174a.413.413,0,0,0-.235-.061c-.235,0-.383.145-.383.428h0a.423.423,0,0,1,.333-.129.388.388,0,0,1,.415.381Zm-.225,0c0-.129-.1-.211-.248-.211a.227.227,0,0,0-.264.214c0,.116.092.209.264.209a.214.214,0,0,0,.248-.2Z",
    transform: "translate(-434.725 -325.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36436",
    "data-name": "Path 36436",
    d: "M551.146,396.363a.148.148,0,1,1,.067.145A.148.148,0,0,1,551.146,396.363Zm0,.679a.148.148,0,1,1,.067.144A.148.148,0,0,1,551.146,397.042Z",
    transform: "translate(-437.787 -326.315)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36437",
    "data-name": "Path 36437",
    d: "M552.82,395.762c0-.41.225-.642.529-.642s.529.233.529.642-.225.642-.529.642S552.82,396.172,552.82,395.762Zm.809,0c0-.3-.116-.439-.288-.439s-.288.137-.288.439.119.441.288.441S553.629,396.063,553.629,395.762Z",
    transform: "translate(-439.02 -325.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36438",
    "data-name": "Path 36438",
    d: "M557.35,395.762c0-.41.225-.642.529-.642s.529.233.529.642-.225.642-.529.642S557.35,396.172,557.35,395.762Zm.811,0c0-.3-.119-.439-.291-.439s-.285.137-.285.439.116.441.285.441S558.161,396.063,558.161,395.762Z",
    transform: "translate(-442.352 -325.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36439",
    "data-name": "Path 36439",
    d: "M567.723,393.795h-.433V392.55h1.245v.431h-.811Z",
    transform: "translate(-449.665 -323.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36440",
    "data-name": "Path 36440",
    d: "M568.535,399.942H567.29V398.7h.431v.811h.814Z",
    transform: "translate(-449.665 -328.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36441",
    "data-name": "Path 36441",
    d: "M576.042,399.935H574.8V399.5h.809v-.814h.433Z",
    transform: "translate(-455.191 -328.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36442",
    "data-name": "Path 36442",
    d: "M576.035,393.792H575.6v-.811h-.814v-.431h1.245Z",
    transform: "translate(-455.183 -323.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36443",
    "data-name": "Path 36443",
    d: "M181.791,183.08h-6.8l-3.4,5.891,3.4,5.888h6.8l3.4-5.888Z",
    transform: "translate(-158.538 -169.52)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36444",
    "data-name": "Path 36444",
    d: "M183.413,191.543a6,6,0,0,1-.83-1.073,2.053,2.053,0,0,1-.283-1.305,7.25,7.25,0,0,0,.172-.774c.026-.365-.127-.745,0-1.086.2-.529.917-.616,1.353-.983.338-.288.5-.753.877-.994a1.652,1.652,0,0,1,1.128-.153,4.163,4.163,0,0,0,1.155.1,7.782,7.782,0,0,0,.793-.214,1.086,1.086,0,0,1,.793.055.529.529,0,0,1,.217.706.879.879,0,0,1,1.134.616,1.321,1.321,0,0,1-.5,1.3,2.907,2.907,0,0,1-1.348.55,5.6,5.6,0,0,1-4.022-.626",
    transform: "translate(-166.407 -170.941)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36445",
    "data-name": "Path 36445",
    d: "M192.267,195.979c-.045-.843-.28-2.571-.513-4.133a3.261,3.261,0,0,0-3.436-2.775h-.169c-1.808.227-2.624,1.89-2.347,3.7l.529,6.488h4.413s-.106-1.139-.106-1.15A2.1,2.1,0,0,0,192.267,195.979Z",
    transform: "translate(-168.955 -173.923)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36446",
    "data-name": "Path 36446",
    d: "M197.788,221.834a4.088,4.088,0,0,1-2.318-.494,2.159,2.159,0,0,0,2.352.946Z",
    transform: "translate(-176.107 -197.669)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36447",
    "data-name": "Path 36447",
    d: "M204.985,204.671a.246.246,0,0,1-.222.264.235.235,0,0,1-.264-.206.248.248,0,0,1,.222-.264.235.235,0,0,1,.264.206Z",
    transform: "translate(-182.749 -185.252)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36448",
    "data-name": "Path 36448",
    d: "M204.5,202.265c-.029.034-.227-.092-.5-.074s-.455.166-.486.135,0-.074.1-.143a.692.692,0,0,1,.386-.148.65.65,0,0,1,.4.1C204.482,202.194,204.513,202.249,204.5,202.265Z",
    transform: "translate(-182.018 -183.465)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36449",
    "data-name": "Path 36449",
    d: "M195.406,205.355a.264.264,0,0,1-.222.264.24.24,0,0,1-.264-.209.264.264,0,0,1,.222-.264.24.24,0,0,1,.264.209Z",
    transform: "translate(-175.702 -185.754)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36450",
    "data-name": "Path 36450",
    d: "M194.54,203.117c-.029.034-.227-.092-.5-.074s-.455.164-.486.135,0-.074.1-.143a.687.687,0,0,1,.793-.05C194.521,203.043,194.553,203.1,194.54,203.117Z",
    transform: "translate(-174.691 -184.089)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36451",
    "data-name": "Path 36451",
    d: "M200.732,204.842a1.752,1.752,0,0,1,.431-.108c.069,0,.132-.029.14-.077a.349.349,0,0,0-.058-.2l-.238-.507a9.158,9.158,0,0,1-.547-1.321,8.9,8.9,0,0,1,.653,1.287c.079.177.156.349.23.51a.42.42,0,0,1,.053.264.18.18,0,0,1-.106.108.529.529,0,0,1-.116.024A1.735,1.735,0,0,1,200.732,204.842Z",
    transform: "translate(-179.778 -183.904)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36452",
    "data-name": "Path 36452",
    d: "M193.887,199.3c-.021.074-.291.058-.6.119s-.56.161-.608.1.021-.1.119-.18a1.023,1.023,0,0,1,.441-.188.991.991,0,0,1,.478.024C193.835,199.211,193.9,199.264,193.887,199.3Z",
    transform: "translate(-174.041 -181.328)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36453",
    "data-name": "Path 36453",
    d: "M204.116,199.285c-.045.063-.233.013-.455.024s-.407.069-.455,0,0-.092.082-.156a.621.621,0,0,1,.362-.124.642.642,0,0,1,.37.1C204.1,199.192,204.135,199.253,204.116,199.285Z",
    transform: "translate(-181.785 -181.253)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36454",
    "data-name": "Path 36454",
    d: "M183.7,207.93c-.032,0-1.224-.264-1.1.917s1.409.793,1.406.766S183.7,207.93,183.7,207.93Z",
    transform: "translate(-166.63 -187.784)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36455",
    "data-name": "Path 36455",
    d: "M184.311,210.283a.372.372,0,0,1-.05.034.209.209,0,0,1-.156.018.513.513,0,0,1-.283-.436.661.661,0,0,1,.029-.3.238.238,0,0,1,.14-.177.108.108,0,0,1,.127.045c.021.032.016.058.021.058s.024-.021,0-.071a.135.135,0,0,0-.053-.069.15.15,0,0,0-.119-.018.3.3,0,0,0-.2.206.708.708,0,0,0-.037.338.529.529,0,0,0,.351.484.227.227,0,0,0,.188-.05C184.327,210.323,184.327,210.283,184.311,210.283Z",
    transform: "translate(-167.467 -188.856)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36456",
    "data-name": "Path 36456",
    d: "M191.11,189.381c-.082.473-1.044.909-1.85.885a3.511,3.511,0,0,1-1.631-.645.892.892,0,0,0-.793-.09c-.37.061-.563.5-.769.811a4.729,4.729,0,0,1,.066,2.8.465.465,0,0,1-.119.283.381.381,0,0,1-.484-.071,1.485,1.485,0,0,1-.375-.756,4.939,4.939,0,0,1-.116-1.937,3.338,3.338,0,0,1,.793-1.747,3.171,3.171,0,0,1,2.164-.986,3.9,3.9,0,0,1,2.307.653,2.323,2.323,0,0,1,.793.793",
    transform: "translate(-168.399 -173.089)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36457",
    "data-name": "Path 36457",
    d: "M199.506,212.458l-.608-.283a.2.2,0,0,0-.111-.026.167.167,0,0,0-.1.071.56.56,0,0,0-.069.618.473.473,0,0,0,.571.209.647.647,0,0,0,.336-.571Z",
    transform: "translate(-178.375 -190.907)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36458",
    "data-name": "Path 36458",
    d: "M198.914,212.8a.413.413,0,0,1-.357.032.565.565,0,0,1-.314-.264.579.579,0,0,1-.04-.5.579.579,0,0,1,.251-.3.169.169,0,0,1,.159,0c.14.077.233.143.325.2.177.119.283.2.264.217s-.132-.034-.322-.132l-.325-.169h-.048a.5.5,0,0,0-.074.061.46.46,0,0,0-.111.174.476.476,0,0,0,.021.386.494.494,0,0,0,.238.225A1.454,1.454,0,0,0,198.914,212.8Z",
    transform: "translate(-178.09 -190.617)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36459",
    "data-name": "Path 36459",
    d: "M193.155,201.742a1.032,1.032,0,0,0-.063-.3,1.242,1.242,0,0,0-.457-.653,1.184,1.184,0,1,0,0,1.9,1.242,1.242,0,0,0,.457-.653c.053-.188.05-.3.063-.3s0,.029,0,.082a.928.928,0,0,1-.024.23,1.226,1.226,0,0,1-.447.716,1.3,1.3,0,1,1,0-2.053,1.226,1.226,0,0,1,.447.716.918.918,0,0,1,.024.23C193.163,201.716,193.16,201.742,193.155,201.742Z",
    transform: "translate(-172.518 -182.294)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36460",
    "data-name": "Path 36460",
    d: "M204.565,201.394a2.28,2.28,0,0,0-.063-.288,1.2,1.2,0,0,0-.444-.634,1.152,1.152,0,1,0,0,1.85,1.2,1.2,0,0,0,.444-.634c.053-.182.05-.291.063-.291s0,.026,0,.079a1,1,0,0,1-.021.225,1.205,1.205,0,0,1-.436.7,1.268,1.268,0,1,1,0-2,1.21,1.21,0,0,1,.436.7.976.976,0,0,1,.021.225C204.573,201.367,204.571,201.394,204.565,201.394Z",
    transform: "translate(-180.961 -182.062)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36461",
    "data-name": "Path 36461",
    d: "M200.656,203.375c-.026.024-.145-.053-.3-.048s-.264.082-.3.058.074-.19.3-.2S200.69,203.354,200.656,203.375Z",
    transform: "translate(-179.472 -184.315)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36462",
    "data-name": "Path 36462",
    d: "M188.068,204.7c.024.029-.209.241-.515.47a1.773,1.773,0,0,1-.6.359c-.024-.029.209-.24.515-.47A1.747,1.747,0,0,1,188.068,204.7Z",
    transform: "translate(-169.841 -185.427)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36463",
    "data-name": "Path 36463",
    d: "M245.978,204.949c0,.037-3.058.069-6.829.069s-6.829-.032-6.829-.069,3.058-.069,6.829-.069S245.978,204.912,245.978,204.949Z",
    transform: "translate(-203.218 -185.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36464",
    "data-name": "Path 36464",
    d: "M239.9,210.351c0,.037-1.623.069-3.626.069s-3.626-.032-3.626-.069,1.623-.071,3.626-.071S239.9,210.312,239.9,210.351Z",
    transform: "translate(-203.461 -189.532)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2",
    transform: "translate(57.838 18.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36465",
    "data-name": "Path 36465",
    d: "M429.792,245.09a10.407,10.407,0,0,1,4.9,6.343c1.276,4.567,5.18,16.459,5.18,16.459s2.23,2.624,2.468,4.567-.238,6.644-.957,7.521a2.016,2.016,0,0,1-1.739.732l-9.39-.891-3.7-24.757Z",
    transform: "translate(-377.677 -211.157)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36466",
    "data-name": "Path 36466",
    d: "M297.958,234.234s-6.715,2.114-8.388,3.938l5.5,25.571-.1,8.071h31.839c0-.4.285-26.792.285-26.792L329,234.665l-11.308-1.99-2.23-1.755-12.587.64-1.913,1.911Z",
    transform: "translate(-276.89 -200.732)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19299",
    "data-name": "Group 19299",
    transform: "translate(18.124 55.179)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36467",
    "data-name": "Path 36467",
    d: "M315.675,325.994c-.1-.217-.241-.452-.473-.5-.383-.079-.64.373-.769.743a33.71,33.71,0,0,1-4.181,8.163l-.082,3.927a20.3,20.3,0,0,0,4.868-5.352A7.951,7.951,0,0,0,315.675,325.994Z",
    transform: "translate(-310.17 -325.485)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36468",
    "data-name": "Path 36468",
    d: "M254.269,258.36a39.567,39.567,0,0,0-3.129,4.984c-.917,1.969-8.531,18.5-8.985,20.209s-1.638,7.085,1.837,8.332h7.154l7.178-14.516.367-16.847Z",
    transform: "translate(-241.589 -220.921)",
    fill: "#5a4bda"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36469",
    "data-name": "Path 36469",
    d: "M255.2,342.308a3.164,3.164,0,0,0-.489-.328,5.55,5.55,0,0,0-1.5-.544,7.233,7.233,0,0,0-1.094-.153,4.361,4.361,0,0,0-1.266.09,4.669,4.669,0,0,0-2.408,1.512,6.564,6.564,0,0,0-1.364,2.534,12.645,12.645,0,0,0-.428,2.339c-.069.677-.092,1.229-.116,1.607,0,.18-.021.325-.026.439a.556.556,0,0,1-.021.153,1.152,1.152,0,0,1,0-.153c0-.116,0-.264,0-.439,0-.383.016-.933.071-1.615a12.2,12.2,0,0,1,.4-2.378,6.575,6.575,0,0,1,1.382-2.59,4.757,4.757,0,0,1,2.484-1.543,4.321,4.321,0,0,1,1.29-.071,6.955,6.955,0,0,1,1.107.172,5.22,5.22,0,0,1,1.506.592,2.644,2.644,0,0,1,.357.264A.75.75,0,0,1,255.2,342.308Z",
    transform: "translate(-245.188 -281.829)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36470",
    "data-name": "Path 36470",
    d: "M266.63,334.461a.931.931,0,0,1,.241-.037,4.282,4.282,0,0,1,.663,0,5.532,5.532,0,0,1,.975.145,5.814,5.814,0,0,1,2.17,1.036,5.409,5.409,0,0,1,.727.666,4.271,4.271,0,0,1,.41.529.906.906,0,0,1,.122.211c-.021.016-.217-.264-.6-.666a6.487,6.487,0,0,0-.732-.632,6.6,6.6,0,0,0-1.015-.608,6.962,6.962,0,0,0-1.11-.407,6.34,6.34,0,0,0-.951-.169C266.976,334.458,266.63,334.488,266.63,334.461Z",
    transform: "translate(-260.012 -276.874)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36471",
    "data-name": "Path 36471",
    d: "M268.15,330.818a1.476,1.476,0,0,1-.33-.024c-.211-.026-.515-.058-.9-.087a15.307,15.307,0,0,0-5.848.7c-.362.116-.653.219-.851.3a1.662,1.662,0,0,1-.314.1,1.322,1.322,0,0,1,.293-.153c.193-.092.481-.209.84-.338a13.5,13.5,0,0,1,5.891-.7c.378.04.685.085.893.129a1.736,1.736,0,0,1,.322.077Z",
    transform: "translate(-255.068 -274.026)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36472",
    "data-name": "Path 36472",
    d: "M342.061,250.484a.376.376,0,0,1-.074-.087l-.2-.264-.719-.994c-.616-.872-1.477-2.088-2.489-3.515l.111-.016c-.386,1.131-.811,2.378-1.258,3.7l-.029.082-.074-.048-.148-.1a7.615,7.615,0,0,1-1.557-1.321,9.263,9.263,0,0,1-1.113-1.538,12.968,12.968,0,0,1-1.224-2.952,20.629,20.629,0,0,1-.462-2.114c-.042-.238-.074-.431-.1-.576a.92.92,0,0,0-.034-.145.125.125,0,0,0-.016-.05,4.011,4.011,0,0,1,.2.764,20.878,20.878,0,0,0,.5,2.088,13.05,13.05,0,0,0,1.239,2.923,9.438,9.438,0,0,0,1.1,1.512,7.5,7.5,0,0,0,1.528,1.29l.145.1-.1.037c.452-1.321.88-2.561,1.271-3.7l.04-.116.071.1c.994,1.44,1.85,2.666,2.45,3.544.288.428.529.769.69,1.017l.177.264A.627.627,0,0,1,342.061,250.484Z",
    transform: "translate(-308.606 -207.817)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19300",
    "data-name": "Group 19300",
    transform: "translate(41.674 54.873)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36473",
    "data-name": "Path 36473",
    d: "M399.347,324.33a15.039,15.039,0,0,0,8.206,14.68c.087-2.624-.04-5.716.048-8.34Z",
    transform: "translate(-399.281 -324.33)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36474",
    "data-name": "Path 36474",
    d: "M396.694,293.845s-1.158.32-.291,2.69,1.158,2.225,1.736,4.44a15.477,15.477,0,0,0,2.262,5.492,33.449,33.449,0,0,0,4.77,3.806l3.372-3.171a16.276,16.276,0,0,1-.423-3.98c.132-1.6.47-5.55.423-6.234a11.1,11.1,0,0,0-.772-2.312v-1.121l-1.734-5.333s-.965-.433-1.3,1.107l-.579-1.636s-.914-.145-1.155,1.734a18.906,18.906,0,0,0,.193,4.479l-.484,3.274-.721,2.217-.626.1s-.943-.264-1.459-2.032S397.994,293.46,396.694,293.845Z",
    transform: "translate(-355.253 -242.426)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36475",
    "data-name": "Path 36475",
    d: "M428.545,324.293a.684.684,0,0,0-.016-.119,3.321,3.321,0,0,1-.024-.354c-.018-.322-.042-.769-.071-1.321-.053-1.15-.124-2.751-.209-4.619l.013.04a.679.679,0,0,0-.682-.18,1,1,0,0,0-.624.46,4.469,4.469,0,0,0-.4,1.686c-.182,1.35-.357,2.643-.515,3.808-.079.587-.164,1.142-.278,1.657a10.468,10.468,0,0,1-.42,1.406,11.34,11.34,0,0,0-.362,1.144,3.559,3.559,0,0,0-.108.885,2.815,2.815,0,0,0,.132.756,1.172,1.172,0,0,1-.079-.185,1.99,1.99,0,0,1-.106-.568,3.37,3.37,0,0,1,.087-.912,10.306,10.306,0,0,1,.346-1.158,10.8,10.8,0,0,0,.4-1.4c.108-.51.19-1.057.264-1.649.153-1.173.325-2.458.5-3.811.042-.3.074-.6.127-.893a2.354,2.354,0,0,1,.3-.848,1.136,1.136,0,0,1,.711-.513.793.793,0,0,1,.811.222l.013.018v.021c.066,1.868.122,3.47.161,4.622,0,.558.024,1,.034,1.321v.354A.6.6,0,0,1,428.545,324.293Z",
    transform: "translate(-376.375 -264.485)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36476",
    "data-name": "Path 36476",
    d: "M430.065,307.25a1.319,1.319,0,0,1-.143-.3,8.032,8.032,0,0,1-.283-.862,8.888,8.888,0,0,1-.241-1.321,3.84,3.84,0,0,1-.016-.793,1.726,1.726,0,0,1,.291-.825,1.184,1.184,0,0,1,.618-.465l.05-.013.026.045c.489.862.914,1.623,1.21,2.17l.346.647a1.029,1.029,0,0,1,.111.243,1.2,1.2,0,0,1-.153-.219l-.381-.626c-.317-.529-.758-1.287-1.25-2.146l.077.032a1.057,1.057,0,0,0-.542.412,1.586,1.586,0,0,0-.264.761,3.808,3.808,0,0,0,0,.777,9.921,9.921,0,0,0,.209,1.321c.085.37.177.666.238.869A1.552,1.552,0,0,1,430.065,307.25Z",
    transform: "translate(-379.744 -253.521)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36477",
    "data-name": "Path 36477",
    d: "M428.533,299.936a1.237,1.237,0,0,1-.032-.309c0-.227-.021-.507-.034-.838-.021-.708-.045-1.686-.058-2.767a23.938,23.938,0,0,1,.042-2.772,4.353,4.353,0,0,1,.18-.825.962.962,0,0,1,.124-.285,7.748,7.748,0,0,0-.209,1.12c-.066.7,0,1.678,0,2.759s.021,2.059.018,2.767v.84A1.417,1.417,0,0,1,428.533,299.936Z",
    transform: "translate(-379.022 -245.774)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36478",
    "data-name": "Path 36478",
    d: "M418.147,340.057c-.018-.016.193-.264.452-.716a6.024,6.024,0,0,0,.394-.822,6.779,6.779,0,0,0,.3-1.073,6.657,6.657,0,0,0,.093-1.11,6.154,6.154,0,0,0-.079-.906c-.087-.515-.2-.822-.174-.83a.792.792,0,0,1,.1.209,3.809,3.809,0,0,1,.174.6,5.153,5.153,0,0,1,.111.922,5.457,5.457,0,0,1-.4,2.233,5.162,5.162,0,0,1-.425.825,3.793,3.793,0,0,1-.373.5C418.213,340,418.155,340.062,418.147,340.057Z",
    transform: "translate(-371.487 -277.013)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36479",
    "data-name": "Path 36479",
    d: "M433.141,349l2.926,1.015s2.8-1.446,4.722,0,3.6,5.254,3.071,6.794c0,0-1.321,1.644-2.341,1.884s-4.944-.714-6.58-1.057a18.935,18.935,0,0,1-4.458-2.178Z",
    transform: "translate(-380.561 -287.607)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36480",
    "data-name": "Path 36480",
    d: "M441.467,346.867a1.173,1.173,0,0,1-.032-.264c0-.2-.024-.433-.04-.708-.032-.6-.071-1.422-.085-2.336s.013-1.742.066-2.339c.026-.3.061-.529.09-.706a.878.878,0,0,1,.061-.264c.021,0-.024.37-.053.967s-.04,1.419-.026,2.331.032,1.7.042,2.334v.708a.866.866,0,0,1-.024.277Z",
    transform: "translate(-388.527 -281.169)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36481",
    "data-name": "Path 36481",
    d: "M456.26,346.575a9.313,9.313,0,0,0-.973-.877,5.357,5.357,0,0,0-5.93-.325,9.556,9.556,0,0,0-1.057.764,1.565,1.565,0,0,1,.24-.264,4.849,4.849,0,0,1,.774-.587,5.262,5.262,0,0,1,6.041.336,4.64,4.64,0,0,1,.7.669A1.49,1.49,0,0,1,456.26,346.575Z",
    transform: "translate(-393.672 -284.289)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36482",
    "data-name": "Path 36482",
    d: "M453.4,340.068a5.844,5.844,0,0,0-1.218-.671,5.375,5.375,0,0,0-3.293-.1,7.7,7.7,0,0,0-1.7.708,8.089,8.089,0,0,0-1.234.872c-.328.28-.579.529-.751.7a2.115,2.115,0,0,1-.277.264,1.817,1.817,0,0,1,.238-.3,9.139,9.139,0,0,1,.727-.732,7.593,7.593,0,0,1,1.234-.906,7.321,7.321,0,0,1,1.731-.732,5.264,5.264,0,0,1,3.367.14,3.906,3.906,0,0,1,.9.507c.1.071.164.14.214.182A.29.29,0,0,1,453.4,340.068Z",
    transform: "translate(-391.185 -280.221)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36483",
    "data-name": "Path 36483",
    d: "M451.877,333.855c0,.026-.529-.13-1.369-.243a10.739,10.739,0,0,0-1.5-.1,11.765,11.765,0,0,0-1.831.164,11.987,11.987,0,0,0-1.779.47,10.55,10.55,0,0,0-1.377.6c-.758.4-1.187.719-1.2.7a1.875,1.875,0,0,1,.293-.233,3.366,3.366,0,0,1,.362-.248c.145-.092.309-.2.5-.3a10.155,10.155,0,0,1,1.382-.634,10.888,10.888,0,0,1,1.8-.486,11.114,11.114,0,0,1,1.85-.156,9.893,9.893,0,0,1,1.514.124c.214.026.4.077.571.111a4.107,4.107,0,0,1,.428.111A2.176,2.176,0,0,1,451.877,333.855Z",
    transform: "translate(-389.64 -276.122)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36484",
    "data-name": "Path 36484",
    d: "M372.259,237.23a2.429,2.429,0,0,1,.2.777,7.479,7.479,0,0,1-.111,2.27,13.005,13.005,0,0,1-.378,1.586,12.038,12.038,0,0,1-.766,1.757c-.632,1.216-1.424,2.54-2.344,3.964l-.106.166v-3.132l.1.05-2.482,1.979.021-.032a25.963,25.963,0,0,0-1.078,5.933,69,69,0,0,0,.1,9.083c.151,2.791.217,5.309.3,7.423s.159,3.821.222,5c.037.587.063,1.041.082,1.358,0,.151.018.264.024.354a.648.648,0,0,1,0,.122.592.592,0,0,0-.018-.119c-.018-.079-.021-.2-.037-.354-.029-.309-.066-.766-.106-1.358-.079-1.179-.172-2.888-.264-5s-.206-4.627-.333-7.421a73.519,73.519,0,0,1-.114-9.1,25.844,25.844,0,0,1,1.107-5.965v-.018h.016l2.474-1.985.1-.085v3.066l-.108-.034c1.816-2.814,3.293-5.262,3.52-7.241a7.76,7.76,0,0,0,.143-2.252,4.043,4.043,0,0,0-.108-.587A2.1,2.1,0,0,1,372.259,237.23Z",
    transform: "translate(-332.441 -205.375)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36485",
    "data-name": "Path 36485",
    d: "M372.15,366.22h-.085a.743.743,0,1,0,.1,0Z",
    transform: "translate(-337.073 -300.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36486",
    "data-name": "Path 36486",
    d: "M372.157,327.68h-.085a.74.74,0,1,0,.1,0Z",
    transform: "translate(-337.08 -271.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36487",
    "data-name": "Path 36487",
    d: "M371.925,289.058a.746.746,0,0,0,.1-1.488h-.1a.745.745,0,0,0,0,1.491Z",
    transform: "translate(-336.933 -242.411)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36488",
    "data-name": "Path 36488",
    d: "M321.158,136.61a19.159,19.159,0,0,1-2.534-3.269,6.152,6.152,0,0,1-.856-3.964c.132-.793.47-1.559.529-2.378.074-1.11-.391-2.27,0-3.309.613-1.628,2.8-1.879,4.131-3,1.033-.875,1.535-2.294,2.672-3.029a5.013,5.013,0,0,1,3.436-.465,13.007,13.007,0,0,0,3.523.3,22.592,22.592,0,0,0,2.439-.653,3.28,3.28,0,0,1,2.46.169,1.6,1.6,0,0,1,.661,2.151,2.68,2.68,0,0,1,3.457,1.882,4.052,4.052,0,0,1-1.525,3.964,9.01,9.01,0,0,1-4.109,1.678,17.16,17.16,0,0,1-12.262-1.911",
    transform: "translate(-297.59 -116.69)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36489",
    "data-name": "Path 36489",
    d: "M343.526,159.666c-.2-1.586-.37-2.888-.381-3.052,0,0,5.264-1.184,4.974-6.506-.14-2.574-.859-7.849-1.567-12.614a9.926,9.926,0,0,0-10.486-8.457l-.529.032c-5.51.7-8,5.764-7.156,11.255l2.976,18.412s1.268,4.072,3.983,4.778l3.435,4.894.566-2.114,2.553-2.225a10.059,10.059,0,0,0,1.261-1.874A4.112,4.112,0,0,0,343.526,159.666Z",
    transform: "translate(-305.325 -125.757)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36490",
    "data-name": "Path 36490",
    d: "M365.037,228.969a12.4,12.4,0,0,1-7.067-1.509s1.9,3.718,7.172,2.886Z",
    transform: "translate(-327.214 -198.187)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36491",
    "data-name": "Path 36491",
    d: "M386.911,176.619a.764.764,0,0,1-.682.817.727.727,0,0,1-.827-.634.758.758,0,0,1,.684-.822.727.727,0,0,1,.825.64Z",
    transform: "translate(-347.394 -160.306)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36492",
    "data-name": "Path 36492",
    d: "M385.562,169.33c-.087.106-.692-.283-1.509-.225s-1.38.5-1.485.415c-.045-.04.04-.225.288-.433a2.079,2.079,0,0,1,1.179-.452,1.993,1.993,0,0,1,1.21.3C385.509,169.108,385.6,169.283,385.562,169.33Z",
    transform: "translate(-345.303 -154.904)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36493",
    "data-name": "Path 36493",
    d: "M357.693,178.723a.759.759,0,0,1-.682.814.724.724,0,0,1-.827-.632.764.764,0,0,1,.679-.817.729.729,0,0,1,.83.634Z",
    transform: "translate(-325.898 -161.857)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36494",
    "data-name": "Path 36494",
    d: "M355.2,171.926c-.09.106-.692-.283-1.509-.225s-1.39.5-1.485.41c-.048-.04.037-.225.285-.433a2.1,2.1,0,0,1,1.181-.452,1.99,1.99,0,0,1,1.208.3C355.143,171.7,355.241,171.878,355.2,171.926Z",
    transform: "translate(-322.963 -156.81)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36495",
    "data-name": "Path 36495",
    d: "M374.019,177.185a5.487,5.487,0,0,1,1.321-.33c.206-.034.4-.09.428-.233a1.071,1.071,0,0,0-.182-.61l-.724-1.549A27.273,27.273,0,0,1,373.2,170.4a27.462,27.462,0,0,1,1.987,3.922l.7,1.559a1.216,1.216,0,0,1,.164.811.529.529,0,0,1-.322.328,1.422,1.422,0,0,1-.351.074A5.49,5.49,0,0,1,374.019,177.185Z",
    transform: "translate(-338.413 -156.204)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36496",
    "data-name": "Path 36496",
    d: "M353.2,160.288c-.066.23-.888.177-1.85.357s-1.71.494-1.85.3c-.063-.093.058-.309.357-.547a3.274,3.274,0,0,1,2.809-.5C353.043,160.019,353.233,160.183,353.2,160.288Z",
    transform: "translate(-320.973 -148.391)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36497",
    "data-name": "Path 36497",
    d: "M384.414,160.3c-.129.2-.706.042-1.385.077s-1.242.209-1.387.024c-.063-.09.016-.283.264-.476a2.014,2.014,0,0,1,2.233-.079C384.382,160.02,384.472,160.194,384.414,160.3Z",
    transform: "translate(-344.615 -148.22)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36498",
    "data-name": "Path 36498",
    d: "M322.077,186.39c-.093-.032-3.726-.835-3.367,2.793S323,191.628,323,191.525,322.077,186.39,322.077,186.39Z",
    transform: "translate(-298.311 -167.899)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36499",
    "data-name": "Path 36499",
    d: "M323.977,193.77c-.019,0-.058.05-.161.108a.629.629,0,0,1-.47.058,1.545,1.545,0,0,1-.864-1.321,2.114,2.114,0,0,1,.087-.922.737.737,0,0,1,.428-.529.325.325,0,0,1,.391.137c.058.1.042.172.061.174s.071-.066.029-.214a.412.412,0,0,0-.167-.214.491.491,0,0,0-.37-.074.893.893,0,0,0-.6.629,2.143,2.143,0,0,0-.119,1.033,1.632,1.632,0,0,0,1.076,1.475.679.679,0,0,0,.571-.153C323.979,193.857,324,193.775,323.977,193.77Z",
    transform: "translate(-300.898 -171.336)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36500",
    "data-name": "Path 36500",
    d: "M344.7,130.013c-.248,1.446-3.171,2.77-5.608,2.7-2.238-.066-3.346-1.176-4.971-1.966-1.031-.5-1.031-.5-2.429-.264-1.128.182-1.715,1.517-2.349,2.468,1.208,2.643.719,5.7.206,8.552a1.443,1.443,0,0,1-.367.867,1.157,1.157,0,0,1-1.469-.222,4.5,4.5,0,0,1-1.144-2.307,14.926,14.926,0,0,1-.359-5.9,10.227,10.227,0,0,1,2.452-5.338,9.688,9.688,0,0,1,6.607-3.01,11.892,11.892,0,0,1,7.035,2,7.081,7.081,0,0,1,2.4,2.423",
    transform: "translate(-303.743 -123.231)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36501",
    "data-name": "Path 36501",
    d: "M370.265,200.365l-1.85-.862a.61.61,0,0,0-.336-.085.529.529,0,0,0-.32.217,1.715,1.715,0,0,0-.206,1.89,1.448,1.448,0,0,0,1.736.64,1.967,1.967,0,0,0,1.025-1.742Z",
    transform: "translate(-334.123 -177.555)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36502",
    "data-name": "Path 36502",
    d: "M368.752,201.662c0,.016-.087.069-.264.108a1.6,1.6,0,0,1-.793-.058,1.652,1.652,0,0,1-.917-.764,1.7,1.7,0,0,1-.114-1.459,1.768,1.768,0,0,1,.428-.647,1.7,1.7,0,0,1,.3-.227.476.476,0,0,1,.214-.066.491.491,0,0,1,.214.04,3.289,3.289,0,0,1,.288.164l.251.156.452.28a4.182,4.182,0,0,1,.859.613,4.017,4.017,0,0,1-.957-.444l-.468-.264-.264-.145c-.09-.045-.185-.106-.264-.137a.2.2,0,0,0-.2.021,1.438,1.438,0,0,0-.243.193,1.586,1.586,0,0,0-.359.55,1.49,1.49,0,0,0,.079,1.239,1.527,1.527,0,0,0,.764.7,1.863,1.863,0,0,0,.716.135C368.646,201.659,368.744,201.644,368.752,201.662Z",
    transform: "translate(-333.527 -176.916)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36503",
    "data-name": "Path 36503",
    d: "M351.375,168.045a6.454,6.454,0,0,0-.145-.92,3.747,3.747,0,0,0-4.913-2.582,3.563,3.563,0,0,0-.943.51,3.436,3.436,0,0,0-.793.793,3.7,3.7,0,0,0,0,4.4,3.435,3.435,0,0,0,.793.793,3.563,3.563,0,0,0,.943.51,3.758,3.758,0,0,0,4.913-2.582,6.521,6.521,0,0,0,.145-.917.2.2,0,0,1,0,.061v.18a1.536,1.536,0,0,1-.021.293,2.959,2.959,0,0,1-.071.4,3.628,3.628,0,0,1-.41,1.023,3.824,3.824,0,0,1-4.6,1.665,3.632,3.632,0,0,1-.975-.529,3.583,3.583,0,0,1-.819-.817,3.832,3.832,0,0,1,0-4.559,3.523,3.523,0,0,1,.817-.817,3.634,3.634,0,0,1,.975-.529,3.827,3.827,0,0,1,4.6,1.665,3.629,3.629,0,0,1,.41,1.023,2.959,2.959,0,0,1,.071.4,1.541,1.541,0,0,1,.021.293v.18a.229.229,0,0,1,0,.069Z",
    transform: "translate(-316.734 -151.639)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36504",
    "data-name": "Path 36504",
    d: "M386.169,166.982a6.532,6.532,0,0,0-.14-.9,3.681,3.681,0,0,0-1.348-2,3.581,3.581,0,0,0-1.533-.674,3.644,3.644,0,0,0-1.908.161,3.551,3.551,0,0,0-.917.494,3.481,3.481,0,0,0-.766.772,3.618,3.618,0,0,0,0,4.286,3.415,3.415,0,0,0,.766.769,3.483,3.483,0,0,0,.917.5,3.671,3.671,0,0,0,1.908.161,3.581,3.581,0,0,0,1.533-.674,3.681,3.681,0,0,0,1.348-2,6.542,6.542,0,0,0,.14-.9,1.448,1.448,0,0,1,0,.235,1.724,1.724,0,0,1-.021.288,2.851,2.851,0,0,1-.069.386,3.723,3.723,0,0,1-2.907,2.775,3.75,3.75,0,1,1,0-7.368,3.724,3.724,0,0,1,2.907,2.775,2.846,2.846,0,0,1,.069.386,1.724,1.724,0,0,1,.021.288A1.448,1.448,0,0,1,386.169,166.982Z",
    transform: "translate(-342.48 -150.933)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36505",
    "data-name": "Path 36505",
    d: "M373.832,173.09c-.016.013-.1-.058-.264-.135a1.5,1.5,0,0,0-.666-.145,1.445,1.445,0,0,0-.658.169c-.159.082-.243.159-.264.143s.048-.116.206-.227a1.3,1.3,0,0,1,1.422-.024A.611.611,0,0,1,373.832,173.09Z",
    transform: "translate(-337.518 -157.876)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36506",
    "data-name": "Path 36506",
    d: "M335.4,176.73a16.707,16.707,0,0,1-1.654,1.321,16.915,16.915,0,0,1-1.739,1.213,15.922,15.922,0,0,1,1.657-1.321A16.423,16.423,0,0,1,335.4,176.73Z",
    transform: "translate(-308.114 -160.863)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19301",
    "data-name": "Group 19301",
    transform: "translate(24.099 33.066)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36507",
    "data-name": "Path 36507",
    d: "M332.837,241.81a10.66,10.66,0,0,0,3.874,9.545.863.863,0,0,0,.774.243.846.846,0,0,0,.4-.412,7.008,7.008,0,0,0,.856-4.609c-.455,1.2-.846,2.378-1.306,3.631C334.935,248.686,333.365,245.452,332.837,241.81Z",
    transform: "translate(-332.778 -241.81)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36508",
    "data-name": "Path 36508",
    d: "M369.87,249.053l2.114-.772.349,3.57s2.278-4.152,3.221-6.044.457-5.238.457-5.238a11.341,11.341,0,0,1-1.945,6.625l-1.723,2.8v-2.933Z",
    transform: "translate(-335.969 -207.832)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19302",
    "data-name": "Group 19302",
    transform: "translate(1.921 58.918)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36509",
    "data-name": "Path 36509",
    d: "M256.294,340.082a5.634,5.634,0,0,0-3.058-.383,5.886,5.886,0,0,0-3.044,1.152,3.37,3.37,0,0,0-1.321,2.873l.106.013a5.08,5.08,0,0,1,4.091-3.618,6.152,6.152,0,0,1,5.021,2.051A2.744,2.744,0,0,0,256.294,340.082Z",
    transform: "translate(-248.856 -339.633)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19303",
    "data-name": "Group 19303",
    transform: "translate(54.913 59.906)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36510",
    "data-name": "Path 36510",
    d: "M457.192,344.86a4.829,4.829,0,0,0-2.727-1.4,6.115,6.115,0,0,0-5.085,1.472l.4-.328a6.419,6.419,0,0,1,3.388-.92,4.892,4.892,0,0,1,3.227,1.29,8.532,8.532,0,0,1,1.718,2.759,3.454,3.454,0,0,0-.922-2.87Z",
    transform: "translate(-449.38 -343.372)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_36511",
    "data-name": "Path 36511",
    d: "M427.45,266.222a1.441,1.441,0,0,1,.1-.288c.082-.209.182-.465.3-.769.264-.647.608-1.541.978-2.537s.69-1.9.92-2.558l.264-.78a1.381,1.381,0,0,1,.116-.28,1.1,1.1,0,0,1-.066.3c-.05.19-.129.46-.233.793-.206.666-.513,1.586-.883,2.577s-.737,1.89-1.017,2.526c-.137.32-.264.576-.341.753A1.214,1.214,0,0,1,427.45,266.222Z",
    transform: "translate(-378.332 -221.399)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36512",
    "data-name": "Path 36512",
    d: "M298.151,271.564c-.037,0-.325-1.25-.642-2.809s-.544-2.814-.515-2.836.322,1.25.639,2.809S298.188,271.556,298.151,271.564Z",
    transform: "translate(-282.349 -226.482)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36513",
    "data-name": "Path 36513",
    d: "M296.8,298.846c.085.042-.967-8.235-.967-8.235s.663-6.282,1.036-6.572v-2.217s1.028-.621,1.3.383c0,0,.912-.793,1.057,1.091s.193,3.808.193,3.808l2.027,5.069.333.169a43.211,43.211,0,0,1,.69-4.556c.254-.592.428-2.006,1.387-1.792s1.041,1.007.869,2.3a18.957,18.957,0,0,0-.307,3.473,22.787,22.787,0,0,1,.344,4.141A8.258,8.258,0,0,1,303,300a31.506,31.506,0,0,1-3.322,4C299.4,304.239,296.8,298.846,296.8,298.846Z",
    transform: "translate(-281.496 -238.042)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36514",
    "data-name": "Path 36514",
    d: "M300.743,299.1a1.583,1.583,0,0,1,0-.354c.016-.264.04-.576.066-.962.061-.811.156-1.932.264-3.171.058-.616.114-1.2.164-1.742a3.1,3.1,0,0,0,0-.748,1.057,1.057,0,0,0-.264-.571,1.131,1.131,0,0,0-.827-.362,2.338,2.338,0,0,0-.346.042.322.322,0,0,1,.085-.042.892.892,0,0,1,.264-.055,1.163,1.163,0,0,1,.9.351,1.131,1.131,0,0,1,.293.621,3.03,3.03,0,0,1,0,.774c-.048.529-.1,1.128-.153,1.744-.114,1.237-.225,2.355-.312,3.171l-.108.959A2.008,2.008,0,0,1,300.743,299.1Z",
    transform: "translate(-284.416 -245.033)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36515",
    "data-name": "Path 36515",
    d: "M304.26,308.469a2.878,2.878,0,0,0-.359.653,10.954,10.954,0,0,0-.336,1.786c-.111.708-.217,1.348-.3,1.81a3.964,3.964,0,0,1-.164.743,4.417,4.417,0,0,1,.069-.758c.058-.465.151-1.107.264-1.816a8.293,8.293,0,0,1,.383-1.8,1.73,1.73,0,0,1,.288-.478C304.191,308.5,304.255,308.463,304.26,308.469Z",
    transform: "translate(-286.844 -257.787)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36516",
    "data-name": "Path 36516",
    d: "M304.67,283.39a.921.921,0,0,1,.071.264c.037.169.082.415.132.721.1.61.211,1.459.283,2.4s.085,1.8.074,2.418c0,.309-.013.56-.026.732a.926.926,0,0,1-.032.264,8.839,8.839,0,0,1-.04-1c-.013-.618-.045-1.469-.114-2.408s-.164-1.786-.24-2.4A8.437,8.437,0,0,1,304.67,283.39Z",
    transform: "translate(-287.999 -239.336)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36517",
    "data-name": "Path 36517",
    d: "M323.415,311.72a.729.729,0,0,1-.682.058c-.388-.116-.568-.415-.529-.428a3.62,3.62,0,0,0,.573.3A3.858,3.858,0,0,0,323.415,311.72Z",
    transform: "translate(-300.896 -259.907)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36518",
    "data-name": "Path 36518",
    d: "M265.106,342.87l-5.354,2.252H256.56s-3.155.986-3.642,3.946-.555,4.479.832,4.847a17.773,17.773,0,0,0,7.249-.238c1.942-.645,7.032-4.757,7.032-4.757l.489-2.97Z",
    transform: "translate(-249.691 -283.097)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36519",
    "data-name": "Path 36519",
    d: "M300.185,341.713a1.408,1.408,0,0,1-.153-.14,3.406,3.406,0,0,1-.346-.444,6.016,6.016,0,0,1-.748-1.694,10.04,10.04,0,0,1-.33-1.818,3.434,3.434,0,0,1-.021-.766,5.159,5.159,0,0,1,.116.753,13.465,13.465,0,0,0,.367,1.794,7.106,7.106,0,0,0,.7,1.681C300.008,341.477,300.2,341.694,300.185,341.713Z",
    transform: "translate(-283.514 -278.668)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36520",
    "data-name": "Path 36520",
    d: "M306.771,338.376a5.585,5.585,0,0,0,.3-1.147,3.7,3.7,0,0,0-.719-2.69c-.325-.455-.692-.851-1-1.237a5.858,5.858,0,0,1-.724-1.094,2.888,2.888,0,0,1-.264-.846,1.075,1.075,0,0,1,0-.322,3.778,3.778,0,0,0,.365,1.123,6.159,6.159,0,0,0,.737,1.057c.309.375.679.772,1.012,1.237a3.848,3.848,0,0,1,.669,1.467,3.73,3.73,0,0,1,.034,1.321,3.473,3.473,0,0,1-.243.851c-.042.1-.082.166-.108.214S306.774,338.379,306.771,338.376Z",
    transform: "translate(-287.767 -274.393)",
    fill: "#eb996e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36521",
    "data-name": "Path 36521",
    d: "M275.316,296.588a26.852,26.852,0,0,1-1.306-2.378,26.213,26.213,0,0,1-1.184-2.439,26.868,26.868,0,0,1,1.306,2.378A26.525,26.525,0,0,1,275.316,296.588Z",
    transform: "translate(-264.57 -245.501)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36522",
    "data-name": "Path 36522",
    d: "M315,262.636a16.426,16.426,0,0,1,.806-1.982,17.034,17.034,0,0,1,.933-1.924,16.957,16.957,0,0,1-.806,1.982,16.756,16.756,0,0,1-.933,1.924Z",
    transform: "translate(-295.599 -221.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36523",
    "data-name": "Path 36523",
    d: "M340.663,289.384a12.211,12.211,0,0,1-1.216-1.358,12.35,12.35,0,0,1-1.107-1.446,11.762,11.762,0,0,1,1.213,1.358A12.214,12.214,0,0,1,340.663,289.384Z",
    transform: "translate(-312.771 -241.683)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36524",
    "data-name": "Path 36524",
    d: "M339.74,322.307a10.537,10.537,0,0,1,.914-1.379,10.094,10.094,0,0,1,1.028-1.3,10.341,10.341,0,0,1-.914,1.38A9.66,9.66,0,0,1,339.74,322.307Z",
    transform: "translate(-313.801 -265.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36525",
    "data-name": "Path 36525",
    d: "M325.253,365.065a2.623,2.623,0,0,1-.309-.529c-.174-.338-.4-.811-.626-1.343s-.41-1.025-.529-1.382a2.667,2.667,0,0,1-.169-.592,2.731,2.731,0,0,1,.264.558l.568,1.361c.219.5.415.962.587,1.356A2.741,2.741,0,0,1,325.253,365.065Z",
    transform: "translate(-301.941 -296.598)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36526",
    "data-name": "Path 36526",
    d: "M349.12,354.5a9.817,9.817,0,0,1-1.6-.24,9.555,9.555,0,0,1-1.586-.375,19.15,19.15,0,0,1,3.171.616Z",
    transform: "translate(-318.356 -291.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36527",
    "data-name": "Path 36527",
    d: "M380,303.729a19.263,19.263,0,0,1,1.527-1.749,19.82,19.82,0,0,1,1.633-1.66,19.878,19.878,0,0,1-1.53,1.752A20.239,20.239,0,0,1,380,303.729Z",
    transform: "translate(-343.422 -251.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36528",
    "data-name": "Path 36528",
    d: "M391.668,358.012c-.029.026-.883-.965-1.908-2.207s-1.831-2.273-1.8-2.3.883.965,1.908,2.207S391.692,357.988,391.668,358.012Z",
    transform: "translate(-349.276 -290.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36529",
    "data-name": "Path 36529",
    d: "M256.607,346.12c.018.037-.761.433-1.612,1.086s-1.443,1.3-1.475,1.268a1.881,1.881,0,0,1,.359-.449,8.126,8.126,0,0,1,1.031-.928,8.247,8.247,0,0,1,1.168-.745,1.991,1.991,0,0,1,.529-.233Z",
    transform: "translate(-250.367 -285.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36530",
    "data-name": "Path 36530",
    d: "M269.658,324a5.632,5.632,0,0,1-.621,1.057,5.548,5.548,0,0,1-.737.983,5.7,5.7,0,0,1,.621-1.057A5.469,5.469,0,0,1,269.658,324Z",
    transform: "translate(-261.241 -269.214)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36531",
    "data-name": "Path 36531",
    d: "M290.508,339.43a3.491,3.491,0,0,1-.513-2.26c.04,0,.053.529.2,1.144S290.545,339.411,290.508,339.43Z",
    transform: "translate(-277.186 -278.903)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36532",
    "data-name": "Path 36532",
    d: "M289.026,276.783a4.059,4.059,0,0,1-1.017.214,3.914,3.914,0,0,1-1.039.077,4.1,4.1,0,0,1,1.02-.214,4.03,4.03,0,0,1,1.036-.077Z",
    transform: "translate(-274.977 -234.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36533",
    "data-name": "Path 36533",
    d: "M303.54,252.07a8.1,8.1,0,0,1-1.85,1.025,4.046,4.046,0,0,1,.891-.573,4.19,4.19,0,0,1,.959-.452Z",
    transform: "translate(-285.807 -216.293)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36534",
    "data-name": "Path 36534",
    d: "M342.529,255.464a18.417,18.417,0,0,1-1.929-2.534A18.421,18.421,0,0,1,342.529,255.464Z",
    transform: "translate(-314.434 -216.926)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36535",
    "data-name": "Path 36535",
    d: "M393.219,280.228a6.472,6.472,0,0,1-1.6-2.569c.04-.016.322.6.766,1.306S393.251,280.2,393.219,280.228Z",
    transform: "translate(-351.971 -235.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36536",
    "data-name": "Path 36536",
    d: "M413.286,293.64a15.4,15.4,0,0,1-1.216,2.677,8.171,8.171,0,0,1,.547-1.366A7.76,7.76,0,0,1,413.286,293.64Z",
    transform: "translate(-367.017 -246.877)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36537",
    "data-name": "Path 36537",
    d: "M412.186,259.131a14.212,14.212,0,0,1-1.337-1.5,14.646,14.646,0,0,1-1.229-1.586A29.288,29.288,0,0,1,412.186,259.131Z",
    transform: "translate(-365.214 -219.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36538",
    "data-name": "Path 36538",
    d: "M389.907,239.506a6.212,6.212,0,0,1-.119-1.279,6.02,6.02,0,0,1,.019-1.287,6.212,6.212,0,0,1,.119,1.279A5.814,5.814,0,0,1,389.907,239.506Z",
    transform: "translate(-350.604 -205.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36539",
    "data-name": "Path 36539",
    d: "M404.862,245.34a10.157,10.157,0,0,1-1.633.288,10,10,0,0,1-1.649.151,10.152,10.152,0,0,1,1.633-.288,9.983,9.983,0,0,1,1.649-.151Z",
    transform: "translate(-359.299 -211.341)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36540",
    "data-name": "Path 36540",
    d: "M446.109,262.123a16.646,16.646,0,0,1-.983-1.871,16.347,16.347,0,0,1-.856-1.932,30.707,30.707,0,0,1,1.839,3.8Z",
    transform: "translate(-390.707 -220.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36541",
    "data-name": "Path 36541",
    d: "M445,288.061a17.174,17.174,0,0,1,.6-2.981,8.571,8.571,0,0,1-.23,1.5A8.336,8.336,0,0,1,445,288.061Z",
    transform: "translate(-391.244 -240.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36542",
    "data-name": "Path 36542",
    d: "M458.216,303.567a16.693,16.693,0,0,1-.793-2.03,16.908,16.908,0,0,1-.653-2.077,32.449,32.449,0,0,1,1.446,4.107Z",
    transform: "translate(-399.904 -251.159)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36543",
    "data-name": "Path 36543",
    d: "M452.973,322.19a3.664,3.664,0,0,1-1.335-.478,3.541,3.541,0,0,1-1.128-.856c.026-.032.513.37,1.195.735S452.986,322.15,452.973,322.19Z",
    transform: "translate(-395.298 -266.899)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36544",
    "data-name": "Path 36544",
    d: "M479.712,345.62a7.545,7.545,0,0,1-.822-1.85A7.546,7.546,0,0,1,479.712,345.62Z",
    transform: "translate(-416.178 -283.759)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36545",
    "data-name": "Path 36545",
    d: "M350.423,378.887a5.265,5.265,0,0,1-.206-1.171,5.343,5.343,0,0,1-.069-1.187,4.963,4.963,0,0,1,.219,1.181A5.163,5.163,0,0,1,350.423,378.887Z",
    transform: "translate(-321.454 -307.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36546",
    "data-name": "Path 36546",
    d: "M419.14,377.44a4.926,4.926,0,0,1,.172-1.144,5,5,0,0,1,.309-1.115,4.838,4.838,0,0,1-.174,1.144A4.913,4.913,0,0,1,419.14,377.44Z",
    transform: "translate(-372.218 -306.868)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    transform: "translate(108.193 16.156)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36547",
    "data-name": "Path 36547",
    d: "M432.16,127.512l2.336-4.08a10.957,10.957,0,1,1,2.624,2.907h0Z",
    transform: "translate(-432.152 -106.694)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36548",
    "data-name": "Path 36548",
    d: "M432.138,127.482l4.96-1.131h.05l-.032-.042h0l-.048.045a11.289,11.289,0,0,0,2.252,1.358,10.957,10.957,0,0,0,3,.856,9.823,9.823,0,0,0,1.734.087c.3-.016.6-.024.906-.048l.925-.14a11.04,11.04,0,0,0,8.692-8.621,11.209,11.209,0,0,0-.129-4.871,10.816,10.816,0,0,0-2.347-4.493l-.452-.515c-.148-.166-.322-.3-.481-.455a4.294,4.294,0,0,0-.5-.433l-.529-.391a4.406,4.406,0,0,0-.544-.359l-.555-.338-.581-.283a5.516,5.516,0,0,0-.587-.264,11.221,11.221,0,0,0-4.908-.753,10.782,10.782,0,0,0-4.493,1.321,11.1,11.1,0,0,0-5.2,6.4,11.787,11.787,0,0,0-.476,3.56,10.836,10.836,0,0,0,.529,3.073,11.178,11.178,0,0,0,1.1,2.357v-.034c-1.464,2.624-2.18,3.906-2.294,4.107.116-.2.851-1.472,2.349-4.075v-.032a11.005,11.005,0,0,1-1.062-2.349,10.818,10.818,0,0,1-.529-3.052,11.829,11.829,0,0,1,.484-3.525,11.023,11.023,0,0,1,5.156-6.316,10.653,10.653,0,0,1,4.453-1.321,11.065,11.065,0,0,1,4.847.748,5.375,5.375,0,0,1,.579.264l.576.28.555.344a4.593,4.593,0,0,1,.529.354l.529.388c.177.127.325.285.489.428a5.087,5.087,0,0,1,.476.449l.441.484a10.722,10.722,0,0,1,2.32,4.448,11.015,11.015,0,0,1,.13,4.81,10.769,10.769,0,0,1-1.823,4.183,10.938,10.938,0,0,1-6.76,4.358l-.914.143c-.3.024-.6.034-.9.05a9.911,9.911,0,0,1-1.718-.079,10.92,10.92,0,0,1-2.986-.83,11.189,11.189,0,0,1-2.244-1.337l-.2-.156.156.2h0l.019-.053Z",
    transform: "translate(-432.13 -106.664)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36549",
    "data-name": "Path 36549",
    d: "M487.4,143.57a1.057,1.057,0,1,0,.31-.761A1.057,1.057,0,0,0,487.4,143.57Z",
    transform: "translate(-472.794 -133.029)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36550",
    "data-name": "Path 36550",
    d: "M471.21,143.57a1.057,1.057,0,1,0,.3-.756A1.057,1.057,0,0,0,471.21,143.57Z",
    transform: "translate(-460.882 -133.029)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36551",
    "data-name": "Path 36551",
    d: "M454.681,143.032a1.057,1.057,0,1,0,.647-.5A1.057,1.057,0,0,0,454.681,143.032Z",
    transform: "translate(-448.621 -133.025)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLdss);
export default __webpack_public_path__ + "static/media/ldss.72e1a655996a8a6651a7a94e937b3407.svg";
export { ForwardRef as ReactComponent };